import SDKMessageBus from '../utility/message-bus';
import { Maybe } from 'maybe-not';

export default function canUser(messageBus: SDKMessageBus, platformCapabilities: Set<string>) {
    if (!platformCapabilities.has('canUser')) {
        return;
    }

    return (...capabilities: string[]): Promise<boolean> => {
        return messageBus
            .sendRequest<{ allowed: boolean }>(
                'canUser',
                Maybe.just(JSON.stringify({ capabilities }))
            )
            .then(response => response.value.allowed);
    };
}
